const URL = {
  LIST_USER_MESSAGE: 'UserMessage/GetUserMessagesByFilter',
  EXCEL_EXPORT_USER_MESSAGES: 'Common/ExcelExportUserMessages',
}
export default URL
